
    const data = {"name":"src/core/icons/bank","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M11.5 1 2 6v2h19V6m-5 4v7h3v-7M2 22h19v-3H2m8-9v7h3v-7m-9 0v7h3v-7H4Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            